module.exports = __webpack_public_path__ + "img/step1-fr.aa431dc8.webp";